import { createContext, PropsWithChildren, useContext, useMemo } from "react";

export interface FilterableGalleryContextValue {
    items: unknown[];
    filteredItems: unknown[];
}

const FilterableGalleryContext = createContext<
    FilterableGalleryContextValue | undefined
>(undefined);

export const FilterableGalleryProvider = ({
    items,
    filteredItems,
    children
}: PropsWithChildren<FilterableGalleryContextValue>) => {
    const value = useMemo(
        () => ({ items, filteredItems }),
        [items, filteredItems]
    );
    return (
        <FilterableGalleryContext.Provider value={value}>
            {children}
        </FilterableGalleryContext.Provider>
    );
};

/** Returns undefined outside a FilterableGalleryProvider. */
export const useFilterableGallery = ():
    | FilterableGalleryContextValue
    | undefined => useContext(FilterableGalleryContext);
